export default __webpack_public_path__ + "static/media/product-card.c0ef5f63.svg";